import React from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Toolbar, Typography } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { drawerWidth } from "Frame";
import { toCamelCase } from "lib/utils/toCamelCase";
import LoginButton from "components/authentication/LoginButton";
import Profile from "components/authentication/Profile";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const NavBarMui: React.FC<any> = ({ open, handleDrawerOpen }) => {
  const currentPathname = useLocation()?.pathname;
  const { isAuthenticated } = useAuth0();

  return (
    <AppBar position="fixed" open={open} color="info">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{ mr: 2, ...(open && { display: "none" }) }}
        >
          <MenuIcon style={{ color: '#707070' }} />
        </IconButton>
        <Typography variant="h6" noWrap component="div" fontFamily={'Helvetica Neue LT Std'} fontWeight={'300'} fontSize={28} color={'#1A1A1A'}>
          SE 2050 Database{" "}
          {currentPathname === '/ecom' ? 'ECOM Factors' :
            currentPathname ? toCamelCase(currentPathname.slice(1)) : ""}
        </Typography>
        {isAuthenticated ? (
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Profile />
          </div>
        ) : (
          <LoginButton version="navbar" />
        )}
      </Toolbar>
    </AppBar>
  );
};

export default NavBarMui;